import React from 'react';
import HandbookSearchResults from './HandbookSearchResults';
import { SearchWithKeyboardNavigation as SearchInput, useListContext } from 'framework/list';

type HandbookSearchInputProps = {
  isSearchMode: boolean;
};

const HandbookSearchInput = (props: HandbookSearchInputProps) => {
  const { isSearchMode } = props;
  const { searchBy = () => {} } = useListContext();

  const onFocus = (searchInputRef: React.RefObject<HTMLInputElement>) => {
    const searchValue = searchInputRef?.current?.value;

    if (!isSearchMode && searchValue) {
      searchBy(searchValue);
    }
  };

  return (
    <SearchInput
      {...props}
      sxWrapper={{
        marginBottom: '0.75rem',
        '@media (max-width: 991px)': {
          marginBottom: '0 !important',
        },
        '& .react-autosuggest__input': {
          minWidth: '100% !important',
          width: '100%',
        },
        '& .search-wrapper': {
          marginRight: 0,
        },
      }}
      searchResultsLayout={HandbookSearchResults}
      placeholder="Search"
      onFocusCallback={onFocus}
    />
  );
};

export default HandbookSearchInput;
